module.exports = {
  API_HOST: 'https://api.analytics.leadgroup.su',
  CLIENT_ID: 'testclient',
  CLIENT_SECRET: 'testpass',
  GRANT_TYPE_PASSWORD: 'password',
  GRANT_TYPE_REFRESH_TOKEN: 'refresh_token',
  STATISTICS: {
    CONVERSIONS: 'CONVERSIONS',
    WEBMASTERS: 'WEBMASTERS',
    BUYOUT: 'BUYOUT',
    ORDER_PROCESSING: 'ORDER_PROCESSING',
    OPERATORS_SUMMARY: 'OPERATORS_SUMMARY',
    OPERATORS_EFFICIENCY: 'OPERATORS_EFFICIENCY',
    OPERATORS_ACTIVITY: 'OPERATORS_ACTIVITY',
    OFFER_ACTIVITY_STATISTIC: 'OFFER_ACTIVITY_STATISTIC',
    EXPENSE_EXPECTION: 'EXPENSE_EXPECTION',
    RETURN_REASON: 'RETURN_REASON',
    DASH_ADVERTISE_DEBIT: 'DASH_ADVERTISE_DEBIT',
    REFUNDS: 'REFUNDS',
    PRODUCT: 'PRODUCT',
    OFFER_RENTABILITY: 'OFFER_RENTABILITY',
    WEBMASTERS_PAYMENTS: 'WEBMASTERS_PAYMENTS',
    CALL_STATISTICS: 'CALL_STATISTICS',
    OPERATORS_ANALYSIS: 'OPERATORS_ANALYSIS',
    CALL_CENTER_TIMINGS: 'CALL_CENTER_TIMINGS',
    HOLD_CALLS: 'HOLD_CALLS'
  }
}



// WEBPACK FOOTER //
// ./src/Config.js